import React, {Component, Fragment} from 'react';
import moment from 'moment';
import autobind from 'autobind-decorator'
import { connect } from "react-redux";
import {setActiveDate, setActiveDateIndex, setActiveDateType, setHoverDateIndex, setStandardDate} from "../../../actions/statistics/statisticsActions";
import classnames from 'classnames';
import {thisMondayDate, firstDayOfMonth, now} from "./CommonHelper";
import If from "../../common/control/If";


@connect(state => ({
  standardDate: state.statistics.standardDate,
  activeDate: state.statistics.activeDate,
  activeDateType: state.statistics.activeDateType,
  hoverDateIndex: state.statistics.hoverDateIndex,
  activeDateIndex: state.statistics.activeDateIndex,
}), dispatch => ({
  handleSetStandardDate(standardDate) {
    dispatch(setStandardDate(standardDate))
  },
  // 활성화된 날짜 변경
  handleSetActiveDate(activeDate) {
    dispatch(setActiveDate(activeDate))
  },
  // 활성화된 날짜 타입 변경 (day, week, month)
  handleSetActiveDateType(activeDateType) {
    dispatch(setActiveDateType(activeDateType))
  },
  // 선택된 날짜의 Index
  handleSetActiveDateIndex(activeDateIndex) {
    dispatch(setActiveDateIndex(activeDateIndex))
  },
  // hover된 날짜의 Index
  handleSetHoverDateIndex(hoverDateIndex) {
    dispatch(setHoverDateIndex(hoverDateIndex))
  }
}))
class GraphDate extends Component {
  constructor(props) {

    super(props);
    this.defaultFormat = "YYYY-MM-DD";
    this.state = {
      dateInfo: {},
      availablePreBtn: true,
      availableNextBtn: false,
    };
  }


  componentDidMount() {
    this.changeBtnStatus();
  }


  componentDidUpdate(prevProps) {
    if (this.checkIsChangedActiveDateOrType(prevProps)) {
      this.changeBtnStatus();
    }
  }


  @autobind
  checkIsChangedActiveDateOrType(prevProps) {
    const {activeDate, activeDateType} = this.props;
    return activeDate != prevProps.activeDate || activeDateType != prevProps.activeDateType;
  }


  // 왼쪽 버튼
  @autobind
  prevDate() {

    if (this.state.availablePreBtn) {
      const {gap, standardDate, activeDateType} = this.props;
      const thisGap = gap[activeDateType] * -1;
      const newDate = moment(standardDate).add(thisGap, activeDateType).format(this.defaultFormat);

      this.props.handleSetStandardDate(newDate);
      this.props.handleSetActiveDate(newDate);
    }
  }

  // 오른쪽 버튼
  @autobind
  nextDate() {
    if (this.state.availableNextBtn) {
      const {gap, standardDate, activeDateType} = this.props;
      const thisGap = gap[activeDateType];
      const newStandardDate = moment(standardDate).add(thisGap, activeDateType).format(this.defaultFormat);
      this.props.handleSetStandardDate(newStandardDate);
      this.props.handleSetActiveDate(newStandardDate);
    }
  }


  // 활성화 / 비활성화 버튼 체크
  @autobind
  changeBtnStatus() {

    if (this.props.usePagination == false) {
      return;
    }

    const {minDate, gap, maxDate, standardDate, activeDateType} = this.props;
    const thisGap = gap[activeDateType] * -1;
    const changedMinDate = moment(standardDate).add(thisGap, activeDateType).format(this.defaultFormat);
    let changedMaxDate = maxDate;

    if (activeDateType == 'week') {
      changedMaxDate = thisMondayDate(now(), this.defaultFormat);
    }
    else if (activeDateType == 'month') {
      changedMaxDate = firstDayOfMonth(now(), this.defaultFormat);
    }

    // console.log('thisGap', thisGap, standardDate, changedMinDate);
    // console.log('min : ', changedMinDate, minDate, changedMinDate <= minDate);
    // console.log('max : ', changedMaxDate, standardDate, changedMaxDate <= standardDate);

    if (changedMinDate <= minDate) {
      this.setState({availablePreBtn: false});
    }
    else {
      this.setState({availablePreBtn: true});
    }

    if (changedMaxDate <= standardDate) {
      this.setState({availableNextBtn: false});
    }
    else {
      this.setState({availableNextBtn: true});
    }
  }


  // 그래프 날짜 영역 - 년,월이 바뀔때만 그값을 표시한다
  renderDateItems(list, activeDateType, dateWidth) {
    const {hoverDateIndex, activeDateIndex, useActiveDate} = this.props;
    let prePrefix = '';
    let preValue = '';

    const today = now();
    const thisMonday = thisMondayDate(today, this.defaultFormat);
    const thisFirstDayOfMonth = firstDayOfMonth(today, this.defaultFormat);


    return list.map((item, index) => {

      let prefix, value, unitName = '';
      if (activeDateType == 'month') {
        prefix = item.year + '년';
        value = (item.fullDate == thisFirstDayOfMonth) ? '이번달' : item.month;
        unitName = '월';
      }
      else if (activeDateType == 'week') {
        prefix = item.month + '월';
        value = (item.fullDate == thisMonday) ? '이번주' : item.day;
        unitName = '일';
      }
      else {
        prefix = item.month + '월';
        value = (item.fullDate == today) ? '오늘' : item.day;
        unitName = '일';
      }

      let displayPrefix = (prePrefix != prefix) ? prefix : '';
      let elements = <div className="data_day fst_day"
                          onMouseOver={() => this.changeHoverIndex(index)}
                          key={index} style={{width: dateWidth}}
                          onClick={() => this.changeActiveIndex(index)}
      >

        <span className="num_month">{displayPrefix}</span>
        <span className={classnames({num_day: true, active: this.checkIsAvailableActive(hoverDateIndex, activeDateIndex, index, useActiveDate)})}>
                    {value}</span><span className="ir_pm">{unitName}
                </span>

      </div>;
      prePrefix = prefix;
      preValue = value;
      return elements;
    });
  }

  //
  checkIsAvailableActive(hoverDateIndex, activeDateIndex, index, useActiveDate) {
    if (useActiveDate) {
      return hoverDateIndex == index || activeDateIndex == index;
    }
    else {
      return hoverDateIndex == index;
    }
  }

  @autobind
  changeHoverIndex(index) {
    this.props.handleSetHoverDateIndex(index);
  }

  @autobind
  changeActiveIndex(index) {
    this.props.handleSetActiveDateIndex(index);
    this.props.handleSetActiveDate(this.props.categoryDate[index].fullDate);
  }


  render() {
    const {usePagination, dateWidth, categoryDate, activeDateType} = this.props;
    const {availablePreBtn, availableNextBtn} = this.state;
    const dateList = this.renderDateItems(categoryDate, activeDateType, dateWidth);

    return (
      <Fragment>
        <div className="graph_date">
          <div className="inner_g">
            {dateList}
          </div>
        </div>

        <If condition={usePagination}>
          <Fragment>
            <a className={classnames({link_graph_prev: true, on: availablePreBtn})}
               onClick={this.prevDate}><span className="ico_blog ico_prev">이전</span>
            </a>
            <a className={classnames({link_graph_next: true, on: availableNextBtn})}
               onClick={this.nextDate}><span className="ico_blog ico_next">이전</span>
            </a>
          </Fragment>
        </If>
      </Fragment>
    );
  }
}

export default GraphDate;
